module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "demographics-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, [_vm._l((_vm.filteredDemographics), function(nugget) {
    return _c('div', {
      key: nugget.title
    }, [_c('el-card', {
      staticClass: "nugget-card",
      attrs: {
        "shadow": "hover"
      }
    }, [(_vm.canDelete(nugget.field)) ? _c('span', {
      staticClass: "delete",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Remove from profile",
        "placement": "right-end"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      on: {
        "click": function($event) {
          !_vm.isProfileEditModeOn ? _vm.handleShowAlert() :
            _vm.removeNugget(nugget)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "edit",
      staticStyle: {
        "float": "right",
        "cursor": "pointer",
        "margin-right": "10px"
      }
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "Edit",
        "placement": "left-start"
      }
    }, [_c('i', {
      staticClass: "el-icon-edit",
      on: {
        "click": function($event) {
          !_vm.isProfileEditModeOn ? _vm.handleShowAlert() :
            _vm.editNugget(nugget)
        }
      }
    })])], 1), _vm._v(" "), _c('span', {
      staticClass: "nugget-title"
    }, [_vm._v(_vm._s(nugget.title))]), _vm._v(" "), (nugget.field === 'birth_date') ? _c('div', [_c('span', {
      staticClass: "nugget-value"
    }, [_vm._v(_vm._s(nugget.label.split(" ")[0]))])]) : _c('div', [_c('span', {
      staticClass: "nugget-value"
    }, [_vm._v(_vm._s(nugget.label))])])])], 1)
  }), _vm._v(" "), (_vm.showEditNuggetDialog) ? _c('el-dialog', {
    attrs: {
      "id": "edit-nugget-dialog",
      "top": "30vh",
      "width": "60rem",
      "title": ("Edit " + (_vm.selectedNugget.title)),
      "show-close": true,
      "close-on-click-modal": false,
      "close-on-press-escape": true,
      "visible": _vm.showEditNuggetDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditNuggetDialog = $event
      }
    }
  }, [(_vm.showEditNuggetDialog) ? _c('edit-nugget-dialog', {
    attrs: {
      "nugget": _vm.selectedNugget,
      "visible": _vm.showEditNuggetDialog
    },
    on: {
      "close": function($event) {
        _vm.showEditNuggetDialog = false
      },
      "saveNugget": _vm.saveNugget
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4eb56c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/profile/tabs/DemographicsTab.vue
// module id = 3133
// module chunks = 3